import React from 'react';

/**
 * [Alakart Hatırlatıcı] Yaklaşan alakart planı için geri sayım + alışveriş durumu kartı.
 * Veri kaynağı: GET /api/planning/today-resolve → notice (type=upcoming_plan, planSource=alakart).
 * Today Menu + Dashboard'da ortak kullanılır.
 *
 * notice: { planStartDate, daysUntilStart, shopping: { state:'completed'|'pending'|'none', listId, itemCount, checkedCount } }
 */
export default function AlakartCountdownCard({ notice, onGoShopping, onGoPlan, compact = false }) {
  if (!notice || notice.planSource !== 'alakart' || notice.type !== 'upcoming_plan') return null;

  const days = Number(notice.daysUntilStart ?? 0);
  const shopping = notice.shopping || { state: 'none' };
  const completed = shopping.state === 'completed';
  const pending = shopping.state === 'pending';

  const dayBig = days === 0 ? 'Bugün' : days === 1 ? 'Yarın' : `${days}`;
  const dayUnit = days <= 1 ? '' : 'gün kaldı';

  const formatDate = (iso) => {
    try { return new Date(`${iso}T00:00:00`).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' }); }
    catch { return iso; }
  };

  return (
    <div className={`rounded-[2rem] border border-indigo-200 bg-gradient-to-br from-indigo-50 to-white dark:border-indigo-900/40 dark:from-indigo-900/20 dark:to-slate-900/40 ${compact ? 'p-4' : 'p-5'}`}>
      <div className="flex items-center gap-4">
        {/* Geri sayım */}
        <div className="flex flex-col items-center justify-center shrink-0 rounded-2xl bg-indigo-600 text-white px-4 py-3 min-w-[84px] shadow-md shadow-indigo-500/20">
          <span className="text-2xl font-black leading-none">{dayBig}</span>
          {dayUnit && <span className="mt-1 text-[10px] font-bold uppercase tracking-wide opacity-90">{dayUnit}</span>}
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-[11px] font-black uppercase tracking-[0.18em] text-indigo-600 dark:text-indigo-300">Alakart Planı Yaklaşıyor</p>
          <p className="mt-0.5 text-sm font-bold text-slate-800 dark:text-slate-100">
            Planın <span className="text-indigo-600 dark:text-indigo-300">{formatDate(notice.planStartDate)}</span> başlıyor.
          </p>

          {/* Alışveriş durumu */}
          {shopping.state !== 'none' && (
            <div className="mt-2 flex flex-wrap items-center gap-2">
              {completed ? (
                <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1 text-[12px] font-bold text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
                  <span className="material-symbols-outlined text-[16px]">task_alt</span>
                  Alışveriş tamam — hazırsın!
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1 text-[12px] font-bold text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">
                  <span className="material-symbols-outlined text-[16px]">shopping_cart</span>
                  Alışveriş eksik
                  {Number(shopping.itemCount) > 0 && ` (${shopping.checkedCount}/${shopping.itemCount})`}
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Aksiyon */}
      {pending && (
        <button
          onClick={() => onGoShopping?.(shopping.listId)}
          className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm transition-all hover:brightness-110"
        >
          <span className="material-symbols-outlined text-[18px]">shopping_cart_checkout</span>
          Alışverişi Tamamla
        </button>
      )}
      {completed && onGoPlan && (
        <button
          onClick={onGoPlan}
          className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-xl border border-indigo-300 bg-white/70 px-4 py-2.5 text-sm font-bold text-indigo-700 transition-all hover:bg-white dark:border-indigo-800/50 dark:bg-indigo-900/20 dark:text-indigo-200"
        >
          Planı Gör
          <span className="material-symbols-outlined text-[18px]">arrow_forward</span>
        </button>
      )}
    </div>
  );
}
